import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { MODALS } from 'src/models/ModalModel';
import { closeModal } from 'src/redux/actions/modalActions';

const CantCancelOnlinePayment = () => {
  const dispatch = useAppDispatch();
  const opened = useSelector(
    (state: Store) => state.dialog[DIALOGS.cantCancelOnlinePayment]?.opened
    || false,
  );

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.cantCancelOnlinePayment }));
    dispatch(closeModal({ modal: MODALS.cancelPayments }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="cant-cancel-online-payment"
      open={opened}>
      <DialogTitle id="cant-cancel-online-payment">{t(lang, 'menus.cant_cancel_online_payment')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.is_not_offline_payment')}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CantCancelOnlinePayment;
